/* eslint-disable */
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { auth } from "services/firebase";
import usersService from "services/usersService";
import * as membersService from "services/membersService";
import { linkUserToMember } from "auth-kit/providers/firebase/services/memberLinker";

/**
 * RegisterPage — 공용 최소형 (대화명 1개만 입력)
 * ---------------------------------------------
 * - 로그인된 사용자 기준
 * - displayName 직접 입력 or 자동 생성
 * - membersService.upsertMemberByPhone + usersService.setMemberId
 */

export default function RegisterPage() {
    const nav = useNavigate();
    const [loading, setLoading] = useState(true);
    const [displayName, setDisplayName] = useState("");
    const [errMsg, setErrMsg] = useState("");
    const [autoName, setAutoName] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const u = auth.currentUser;

                console.log("Current user:", u);
                if (!u) return nav("/loginlanding", { replace: true });

                const userDoc = await usersService.getUser(u.uid).catch(() => null);
                const phoneE164 = userDoc?.phoneE164;
                if (!phoneE164) return nav("/auth/phone", { replace: true });

                // 이미 멤버가 존재하면 홈으로 보냄
                const hasMember = await membersService.existsMemberByPhone(phoneE164);
                if (hasMember) return nav("/home", { replace: true });

                // 자동 닉네임 생성 (전화번호 끝 4자리 or 랜덤)
                const last4 = (phoneE164 || "").replace(/\D/g, "").slice(-4);
                const rand = Math.floor(1000 + Math.random() * 9000);
                setAutoName(`회원${last4 || rand}`);
            } catch (e) {
                console.warn("[RegisterPage] preload error:", e);
            } finally {
                setLoading(false);
            }
        })();
    }, [nav]);

    const handleComplete = async () => {
        setErrMsg("");
        try {
            const u = auth.currentUser;
            if (!u) return nav("/loginlanding", { replace: true });

            const userDoc = await usersService.getUser(u.uid).catch(() => null);
            const phoneE164 = userDoc?.phoneE164;
            if (!phoneE164) return nav("/auth/phone", { replace: true });

            // 입력이 없으면 자동 이름 사용
            const finalName = displayName.trim() || autoName;

            // members payload 최소화
            const payload = {
                profile: { displayName: finalName },
                role: "user",
            };

            await linkUserToMember(u, phoneE164, payload);
            nav("/home", { replace: true });
        } catch (e) {
            console.error("[RegisterPage] complete error", e);
            setErrMsg("저장 중 문제가 발생했습니다. 다시 시도해 주세요.");
        }
    };

    if (loading) return <Page>확인 중...</Page>;

    return (
        <Page>
            <Card>
                <h2>대화명 설정</h2>
                <Input
                    placeholder={`예: ${autoName}`}
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                    maxLength={20}
                />
                <Button onClick={handleComplete}>완료</Button>
                {errMsg && <p style={{ color: "#e03131", marginTop: 12 }}>{errMsg}</p>}
            </Card>
        </Page>
    );
}

/* styled-components */
const Page = styled.main`
  min-height: 100dvh;
  display: grid;
  place-content: center;
  background: var(--color-bg, #faf7f3);
  color: var(--color-text, #111);
`;

const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  padding: 32px 24px;
  width: min(90vw, 400px);
  display: grid;
  gap: 16px;
  text-align: center;
`;

const Input = styled.input`
  height: 48px;
  border-radius: 12px;
  border: 1px solid var(--color-border, #ddd);
  background: var(--color-card, #fff);
  padding: 0 12px;
  font-size: 15px;
  text-align: center;
  &::placeholder { color: #aaa; }
`;

const Button = styled.button`
  height: 48px;
  border-radius: 12px;
  font-weight: 900;
  background: var(--color-accent, #D9A679);
  color: #fff;
  border: none;
  cursor: pointer;
  &:active { transform: translateY(1px); filter: brightness(.95); }
`;
